import { Divider, Stack, Typography } from '@mui/material';
import { CaseStudyContentDto } from 'tdc-web-backend/case-studies-content/schemas';
import { formatDateFns } from '../../../../../../../utils/helpers';
import ControlledTextInput from '../../../../../../../components/custom-inputs/ControlledTextInput';
import PitchFeedbackInput from '../../../../../TimedProjects/TimedProjectsDetails/components/PitchFeedbackInput';

const ScoreInputs = ({ data }: { data: CaseStudyContentDto }) => {
  const feedbackFields = [
    {
      title: 'quality',
      description: 'Summarize your working relationship.',
      ratingInputName: 'score.qualityScore',
      textInputName: 'score.qualityText',
    },
    {
      title: 'Budget',
      description: 'Overall value and conformance to cost estimates.',
      ratingInputName: 'score.budgetScore',
      textInputName: 'score.budgetText',
    },
    {
      title: 'schedule',
      description: 'Ability to meet deadlines and meet agreed on project.',
      ratingInputName: 'score.scheduleScore',
      textInputName: 'score.scheduleText',
    },
    {
      title: 'Willingness to refer',
      description: 'Willingness to refer colleague to the company.',
      ratingInputName: 'score.recommendationScore',
      textInputName: 'score.recommendationText',
    },
  ];

  return (
    <Stack
      spacing={1}
      // width={'60%'}
      sx={{ width: { xs: '100%', md: '60%' }, border: '1px solid', borderColor: 'primaryDark.200' }}
    >
      <Stack p={4}>
        <Typography variant="heading1" p={1} color="primaryDark.600">
          {data?.title}
        </Typography>
        <Typography variant="body3" p={1} py={3} color="primaryDark.500">
          {formatDateFns(data?.published)}
        </Typography>
      </Stack>
      <Divider />
      <Stack p={4}>
        <ControlledTextInput
          required
          multiline
          minRows={5}
          name="summarization"
          placeholder="type"
          label="quote"
          showErrorAlways
        />

        {feedbackFields.map((item) => (
          <Stack py={2} key={item.title}>
            <PitchFeedbackInput
              key={item.title}
              description={item.description}
              title={item.title}
              ratingInputName={item.ratingInputName}
              textInputName={item.textInputName}
              showEditor
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default ScoreInputs;
